import { AdsProvider as BaseAdsProvider } from '@folklore/ads';
import { ComponentProps } from 'react';

import { useIsBot } from './AuthContext';

type BaseAdsProviderProps = ComponentProps<typeof BaseAdsProvider>;

interface AdsProviderProps extends BaseAdsProviderProps {
    disabled?: boolean;
}

export function AdsProvider({ disabled = false, ...props }: AdsProviderProps) {
    const isBot = useIsBot();
    return <BaseAdsProvider disabled={disabled || isBot} {...props} />;
}
